var _rect, _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgWhatsapp = function SvgWhatsapp(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 45,
    height: 45,
    viewBox: "0 0 45 45",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    rx: 8,
    fill: "#0EA400"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.5064 31.6113L16.074 31.3472L11.8764 32.4276L13.0188 28.37L12.7271 27.9166C11.5135 26.0273 10.8722 23.8364 10.8722 21.58C10.8722 15.1043 16.141 9.83635 22.6167 9.83635C29.0916 9.83635 34.3604 15.1043 34.3604 21.58C34.3604 28.0557 29.0916 33.3236 22.6167 33.3236C20.4542 33.3236 18.342 32.7319 16.5064 31.6113M10.4206 28.7455L8.4375 35.7904L15.7019 33.9204C17.8074 35.1014 20.1862 35.7233 22.6169 35.7233C30.4152 35.7233 36.7594 29.3784 36.7594 21.58C36.7594 13.7816 30.4152 7.4375 22.6169 7.4375C14.8177 7.4375 8.47354 13.7816 8.47354 21.58C8.47354 24.113 9.14492 26.578 10.4206 28.7455",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6462 14.9972L17.7284 14.9469C17.4401 14.9318 17.1576 15.0273 16.9397 15.2168C16.4946 15.6032 15.783 16.35 15.5651 17.3239C15.239 18.7748 15.7428 20.5517 17.0461 22.3295C18.3486 24.1064 20.7777 26.9495 25.0725 28.164C26.4563 28.5554 27.5451 28.2914 28.3849 27.7541C29.0504 27.3292 29.5089 26.6461 29.674 25.8733L29.8207 25.1893C29.8668 24.9714 29.757 24.751 29.555 24.6579L26.4529 23.228C26.2518 23.135 26.0129 23.1936 25.878 23.3697L24.6601 24.9479C24.5679 25.067 24.4103 25.1147 24.2687 25.0644C23.4347 24.7719 20.6419 23.6018 19.1089 20.6498C19.0426 20.5216 19.0594 20.3665 19.1533 20.2567L20.3167 18.9106C20.4357 18.7731 20.4659 18.5803 20.3946 18.4127L19.0577 15.2855C18.9865 15.1187 18.8264 15.0072 18.6462 14.9972",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgWhatsapp);
export default ForwardRef;